import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import ViewablePasswordField from 'components/ViewablePasswordField';
import AuthWrapper from 'components/AuthWrapper';
import AuthTop from 'components/AuthTop';
import AuthBottom from 'components/AuthBottom';
import Button from 'components/Button';
import FormErrors from 'components/FormErrors';
import './ChangePassword.css';

const SubmitValidationForm = props => {
  const {
    error,
    submitErrors,
    handleSubmit,
    submitting,
    resetPassword
  } = props;
  return (
    <form onSubmit={handleSubmit} className="change-password">
      <AuthWrapper>
        <AuthTop hideLogo>
          {submitErrors && <FormErrors errors={submitErrors} />}
          {error && <FormErrors errors={[error]} />}
          {!resetPassword && (
            <Field
              label="Current Password"
              type="password"
              name="oldPassword"
              component={ViewablePasswordField}
            />
          )}
          <Field
            label="New Password"
            type="password"
            name="password"
            component={ViewablePasswordField}
          />
          <Field
            label="Confirm Password"
            type="password"
            name="confirmPassword"
            component={ViewablePasswordField}
          />
        </AuthTop>
        <AuthBottom>
          <div className="login-bottom">
            <Button
              className="btn btn-success btn-block btn-square"
              disabled={submitting}
            >
              <span>Submit</span>
            </Button>
          </div>
        </AuthBottom>
      </AuthWrapper>
    </form>
  );
};

export default reduxForm({
  form: 'changePasswordForm' // a unique identifier for this form
})(SubmitValidationForm);



// WEBPACK FOOTER //
// ./src/components/ChangePassword/ChangePasswordForm.js